import { render } from "./newFansCount.vue?vue&type=template&id=343ec24a"
import script from "./newFansCount.vue?vue&type=script&lang=js"
export * from "./newFansCount.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__